import React from 'react';

import { MoreInfoTypes } from '../../pages/claims/pet-more-info';

type Props = {
  data: MoreInfoTypes;
};

const ClaimsMoreInfo = ({ data }: Props) => (
  <>
    {data.title}
    {data.paragraph}
    {data.links}
  </>
);

export default ClaimsMoreInfo;
